export const mutateUsers = (state, payload) => {
    const {data, op} = payload;
    if(op === "added") {
        const index = state.users.findIndex((type) => type._id === data._id);
        if(index === -1){
            state.users.push(data);
        } else {
            state.users[index] = {
                ...state.users[index],
                ...data,
            };
        }
    } else if(op === "modified") {
        const index = state.users.findIndex((type) => type._id === data._id);
        if(index !== -1) {
            state.users[index] = data;
        }
    } else if(op === "removed") {
        const index = state.users.findIndex((type) => type._id === data._id);
        if(index !== -1) {
            state.users.splice(index, 1);
        }
    }
}
export const mutateUsersPresence = (state, payload) => {
    const users = Array.isArray(payload) ? payload : [];
    users.forEach((user) => {
        const userId = user.userId || user._id || user.id;
        const index = state.users.findIndex((item) => item._id === userId || item.id === userId);
        if(index !== -1) {
            state.users[index] = {
                ...state.users[index],
                isOnline: user.isOnline,
                lastActive: user.lastActive
            };
        }
    });
}
export const mutateCounts = (state, payload) => {
    state.myCounts = payload;
}
